import { useState } from "react";
import { PageHeader, Tabs } from "@/components/Kit";
import ExamsTab from "./exams/ExamsTab";
import MarksEntryTab from "./exams/MarksEntryTab";
import ProgressRecordTab from "./exams/ProgressRecordTab";
import { CalendarClock, PenLine, FileBadge } from "lucide-react";

export default function Exams() {
  const [tab, setTab] = useState("exams");
  return (
    <div data-testid="exams-page">
      <PageHeader title="Exams & Progress Records" subtitle="Schedule exams, enter class-wise marks and issue the academic-year Progress Record" />
      <Tabs testid="exam-tabs" active={tab} onChange={setTab} tabs={[{ key: "exams", label: "Exam Schedule", icon: CalendarClock }, { key: "marks", label: "Marks Entry", icon: PenLine }, { key: "progress", label: "Progress Record", icon: FileBadge }]} />
      {tab === "exams" && <ExamsTab />}
      {tab === "marks" && <MarksEntryTab />}
      {tab === "progress" && <ProgressRecordTab />}
    </div>
  );
}
